import { render, staticRenderFns } from "./Level0-3.vue?vue&type=template&id=b410cc9a&scoped=true&"
import script from "./Level0-3.vue?vue&type=script&lang=js&"
export * from "./Level0-3.vue?vue&type=script&lang=js&"
import style0 from "./Level0-3.vue?vue&type=style&index=0&id=b410cc9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410cc9a",
  null
  
)

export default component.exports